module.exports = __webpack_public_path__ + "img/how-step-1.c827b993.png";